var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-footer",class:`landing-footer_${_vm.textColor}`},[(_vm.description)?_c('p',[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_c('p',[_vm._v(" "+_vm._s(_vm.disclaimer ?? _vm.$t('landing_male.results_disclaimer'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }